import { Filter } from '@loopback/filter';
import { api } from 'api/api';
import { Count, User } from 'shared/model/user.model';

export const extendedApi = api
  .enhanceEndpoints({
    addTagTypes: ['user', 'users', 'usersCount'],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: builder => ({
      countUsers: builder.query<Count, void>({
        query: () => ({
          url: `/users/count`,
          method: 'GET',
        }),
        providesTags: ['usersCount'],
      }),
      getUsers: builder.query<User[], Filter<User> | void>({
        query: filter => ({
          url: `/users`,
          method: 'GET',
          params: filter
            ? {
                filter: JSON.stringify(filter),
              }
            : undefined,
        }),
        providesTags: ['users'],
      }),
      getUser: builder.query<User, number | string>({
        query: id => ({
          url: `/users/${id}`,
          method: 'GET',
        }),
        providesTags: ['user'],
      }),
      createUser: builder.mutation<void, Omit<User, 'id'>>({
        query: body => ({
          url: `/users`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['users', 'usersCount'],
      }),
      updateUser: builder.mutation<void, Partial<User>>({
        query: body => ({
          url: `/users/${body.id}`,
          method: 'PATCH',
          body,
        }),
        invalidatesTags: ['users', 'usersCount'],
      }),
      removeUser: builder.mutation<void, number>({
        query: id => ({
          url: `/users/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['users', 'usersCount'],
      }),
    }),
  });

export const {
  useGetUserQuery,
  useGetUsersQuery,
  useCountUsersQuery,
  useUpdateUserMutation,
  useCreateUserMutation,
  useRemoveUserMutation,
} = extendedApi;
